import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import service from '@/utils/service.js'
import imageUrl from '@/utils/imageUrl.js'
import sspai from 'sspai-ui'
import 'sspai-ui/lib/sspai-ui.css'
import '@/element-ui'
import '@/assets/styles/global.styl'
import '@/components/icons.js'
import debounce from 'lodash/debounce'
import VueLazyload from 'vue-lazyload'

// if (process.env.NODE_ENV === 'development') {
//   import('sspai-ui/lib/sspai-ui.css')
// }

Vue.use(sspai)
Vue.config.productionTip = false
Vue.config.ignoredElements = [
  'swiper-container',
  'swiper-slide'
]
Vue.prototype.$http = service
Vue.prototype.$imageUrl = imageUrl

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'https://cdnfile.sspai.com/special/314/pic_404.png',
  loading: '',
  attempt: 1,
  adapter: {
    error (listender) {
      service({
        type: 'GET',
        url: listender.src
      }).catch(res => {
        if (res.status === 403) {
          listender.el.src = 'https://cdnfile.sspai.com/special/314/pic_403.png'
        } else {
          listender.el.src = 'https://cdnfile.sspai.com/special/314/pic_404.png'
        }
      })
    }
  }
})

function _setVh () {
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}
_setVh()
window.addEventListener('scroll', debounce(_setVh, 100))
window.addEventListener('resize', debounce(_setVh, 100))

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
